import React, { useState, useEffect, useRef } from 'react';
import { getRandomWords } from './WordAnimation/words';
import './MorphingText.css';

const MorphingText = ({ context = 'landing' }) => { // Add context prop with default value
  const [currentPrefix, setCurrentPrefix] = useState('link');
  const [borderWidth, setBorderWidth] = useState(0);
  const [words, setWords] = useState(getRandomWords());
  const [currentIndex, setCurrentIndex] = useState(0);
  const measuringRef = useRef(null);
  const suffix = 'ist';

  const measureText = (prefix) => {
    if (!measuringRef.current) return 0;
    measuringRef.current.textContent = prefix + suffix;
    return measuringRef.current.getBoundingClientRect().width;
  };

  useEffect(() => {
    const animationSequence = async () => {
      // Fade out current prefix
      setCurrentPrefix('');
      await new Promise(resolve => setTimeout(resolve, 400));
      
      // Calculate next word and update words array if needed
      let nextIndex = (currentIndex + 1);
      let nextWord;
      
      if (nextIndex % 4 === 0) {
        nextWord = 'link';
      } else {
        if (nextIndex >= words.length) {
          const newWords = getRandomWords();
          setWords(newWords);
          nextIndex = 0;
          nextWord = newWords[0];
        } else {
          nextWord = words[nextIndex];
        }
      }
      
      // Adjust border
      const nextWidth = measureText(nextWord);
      setBorderWidth(nextWidth);
      await new Promise(resolve => setTimeout(resolve, 400));
      
      // Fade in new prefix
      setCurrentPrefix(nextWord);
      setCurrentIndex(nextIndex);
    };

    const interval = setInterval(animationSequence, 3000);
    return () => clearInterval(interval);
  }, [currentIndex, words]);

  // Initial setup
  useEffect(() => {
    const initialWidth = measureText('link');
    setBorderWidth(initialWidth);
  }, []);

  // Set the appropriate class based on context
  const containerClass = `morphing-container ${context === 'dashboard' ? 'dashboard-morphing' : 'landing-morphing'}`;

  return (
    <div className={containerClass}> {/* Apply context-specific class */}
      {/* Hidden element for measuring text width */}
      <div 
        ref={measuringRef} 
        className="measuring-text"
        aria-hidden="true"
      />
      
      <div className="morphing-wrapper">
        <div className="morphing-position">
          <div 
            className="morphing-border"
            style={{
              width: `${borderWidth + 30}px`,
            }}
          >
            <div className="text-container">
              {/* Prefix */}
              <span
                className={`prefix ${currentPrefix === 'link' ? 'link-word' : ''}`}
                style={{
                  opacity: currentPrefix ? 1 : 0,
                }}
              >
                {currentPrefix}
              </span>
              {/* Suffix */}
              <span className="suffix">
                {suffix}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MorphingText;